import { PropsWithChildren } from 'react';
import { cn } from '@sib/ui';
import { useUIContext } from '../UIContext';
import { Sidebar } from './Sidebar';
// TODO: implement proper auto logout
// import { useAutoLogout } from '@spendbrain/hooks/use-auto-logout';
import { TopBar, TOPBAR_HEIGHT } from './TopBar';

interface LayoutProps extends PropsWithChildren {}

export const Layout = ({ children }: LayoutProps) => {
  const { sidebarOpen, setSidebarOpen, fullscreenMode } = useUIContext();

  return (
    <div className="flex h-screen flex-col">
      <TopBar />
      <div className="flex flex-1" style={{ paddingTop: TOPBAR_HEIGHT }}>
        <Sidebar
          open={sidebarOpen}
          onChange={setSidebarOpen}
          hidden={fullscreenMode}
        />
        <main
          className={cn(
            'flex-[1_1_0%] transition-all duration-700 ease-in-out'
          )}
        >
          {children}
        </main>
      </div>
    </div>
  );
};

Layout.displayName = 'Layout';
